const HEADER_OFFSET = 78;

// ページ遷移時にハッシュがある場合のスムーススクロール
if (window.location.hash) {
  // ブラウザのデフォルトジャンプを抑制
  window.scrollTo(0, 0);

  window.addEventListener('DOMContentLoaded', () => {
    const targetId = window.location.hash.slice(1);
    const targetElement = document.getElementById(targetId);

    if (targetElement) {
      requestAnimationFrame(() => {
        const targetPosition =
          targetElement.getBoundingClientRect().top + window.scrollY - HEADER_OFFSET;
        window.scrollTo({
          top: targetPosition,
          behavior: 'smooth',
        });
      });
    }
  });
}
